import React from "react";
import "./loading.css"

export default class LoadingSpinner extends React.Component {
    render() {
        return (
            <div class="spinner spinner-blue spinner-slow spinner-large" />
        )
    }
}
